export const GET_COMPANIES__REQUEST = 'USER_TYPE__GET_COMPANIES__REQUEST'
export const GET_COMPANIES__SUCCESS = 'USER_TYPE__GET_COMPANIES__SUCCESS'
export const GET_COMPANIES__FAILURE = 'USER_TYPE__GET_COMPANIES__FAILURE'
